// Flags frontend para capacidades opcionales que no requieren tablas propias.
// El tema base de Core no depende de estos flags.
export const FRONTEND_FEATURES = {
  themeWowdashReference: process.env.REACT_APP_FEATURE_THEME_WOWDASH !== "false",
};

export function isFrontendFeatureEnabled(feature) {
  return Boolean(FRONTEND_FEATURES[feature]);
}
